<ion-text slot="end" [color]="color" [title]="title">{{ rc }}</ion-text>
